export default __webpack_public_path__ + "assets/images/58605c1edf5a6c28b67e81b68c07aa80.svg";